<template>
  <vs-popup class=""
            id="popup"
            title="APPROVE FORMULATIONS"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdate)" autocomplete="off">

<!--          <div class="vx-row mb-3">-->
<!--            <div class="vx-col md:w-full w-full md:mb-0">-->
<!--              <ValidationProvider  vid="name" name="name" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">Dev Code</small>-->
<!--                <vs-input readonly type="text" name="name" class="w-full" v-model="devName" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full">
              <ValidationProvider vid="production_code_id" name="production_code_id" rules="required" v-slot="{ errors }">
                <small class="label">Production code</small>
                <v-select :filter-by="myFilter"  :clearable="false" name="production_code_id" placeholder="" label="prefix" v-model="form.production_code_id" :reduce="option => option.id" :options="production_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.prefix}} - {{option.name}}</span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider  vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input type="text" name="name" class="w-full" v-model="form.name" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <vx-card cardBorder class="mt-4" v-if="linked_customer_pricing.length > 0">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-full w-full md:mb-0">
                <ValidationProvider  vid="is_copy_prices" name="is_copy_prices" rules="required" v-slot="{ errors }">
                  <small class="label">Apply current (dev code) bespoke/contract pricing to production code?</small>
                  <vs-switch v-model="form.is_copy_prices" icon-pack="feather" vs-icon-on="icon-check-circle"
                            vs-icon-off="icon-slash" class="mt-2 w-16">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mt-4">
              <div class="vx-col w-full">
                <h5>Customers with bespoke/contract price:</h5>
                <p v-for="(customer, index) in linked_customer_pricing" :key="index" class="ml-4 mt-2">
                  {{ index + 1 }} - {{ customer.company_name }} ({{ customer.account_number }})
                </p>
              </div>
            </div>
          </vx-card>

          <div class="flex flex-wrap items-center justify-end">
            <vs-button button="submit" class="ml-auto mt-2">Approve</vs-button>
            <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const FormulationsRepository = RepositoryFactory.get('formulations')
  const DropDownRepository = RepositoryFactory.get('drop_down')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      title :'',
      form: {
        name: '',
        is_copy_prices: false,
      },
      production_codes: [],
      devName: '',
      linked_customer_pricing: []
    }
  }

export default {
  name: 'ApproveFormulationPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id, name, formulation_type = null) {
      try {
        await Object.assign(this.$data, initialState())
        this.$vs.loading()
        this.id = id
        this.form.name = name
        await this.loadProductionCodes(formulation_type)
        await this.fetchLinkedCustomerPricing()
        this.open = true;
        this.$vs.loading.close()
      } catch (error) {
        this.$vs.loading.close()

      }
    },

    async onClickUpdate () {
      const vue = this;
      try {
        this.$vs.loading();
        const {data} = (await FormulationsRepository.approveFormulations(this.id, this.form)).data
        vue.showSuccessMessage('The selected formulation was successfully approved');
        vue.$router.replace({path: `/pages/formulations/${data.id}`}, function () {
          location.reload()
        })
      } catch (e) {
        vue.convertAndNotifyError(e)
      }
      vue.$vs.loading.close();
    },
    async loadProductionCodes(formulation_type = null) {
      const filterQuery = formulation_type ? `filter[formulation_type]=${formulation_type}` : null
      const {data} = (await DropDownRepository.getProductionCodesList(filterQuery)).data
      this.production_codes = data
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.prefix.toLowerCase().indexOf(temp) > -1
    },
    async fetchLinkedCustomerPricing() {
      try {
        const { data } = (await FormulationsRepository.getLinkedCustomersPricing(this.id)).data
        this.linked_customer_pricing = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    }
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
